import React from 'react';
import { BookOpen, FileText, Search } from 'lucide-react';

const KnowledgeBase = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <BookOpen className="w-6 h-6" />
          Knowledge Base
        </h1>
        <p className="text-gray-600 mt-1">Find guides, documentation, and helpful resources</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="bg-white p-6 rounded-lg shadow border border-gray-200 hover:shadow-md transition-shadow">
          <FileText className="w-8 h-8 text-indigo-600 mb-3" />
          <h3 className="font-semibold text-gray-900 mb-2">Getting Started</h3>
          <p className="text-sm text-gray-600">Learn the basics of Way2Connect SMS platform</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow border border-gray-200 hover:shadow-md transition-shadow">
          <BookOpen className="w-8 h-8 text-indigo-600 mb-3" />
          <h3 className="font-semibold text-gray-900 mb-2">API Documentation</h3>
          <p className="text-sm text-gray-600">Complete API reference and examples</p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow border border-gray-200 hover:shadow-md transition-shadow">
          <Search className="w-8 h-8 text-indigo-600 mb-3" />
          <h3 className="font-semibold text-gray-900 mb-2">Troubleshooting</h3>
          <p className="text-sm text-gray-600">Common issues and their solutions</p>
        </div>
      </div>

      <div className="mt-8 bg-gray-50 p-6 rounded-lg">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Search</h2>
        <div className="relative">
          <input
            type="text"
            placeholder="Search for articles, guides, or topics..."
            className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
          <Search className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBase;
